import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

// Ikoner for sosiale medier
const IconFacebook = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"></path></svg>;
const IconInstagram = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>;
const IconMapPin = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>;

function ContactInfo() {
  const [content, setContent] = useState({});
  const [isHoursOpen, setIsHoursOpen] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/content/kontakt`).then(res => {
      const organized = res.data.reduce((acc, item) => ({ ...acc, [item.element_id]: item }), {});
      setContent(organized);
    });
  }, []);

  const isHoytid = content.kontakt_apningstider_aktiv?.value === 'hoytid';

  // --- NY LOGIKK HER ---
  const activeHoursKey = content.kontakt_apningstider_aktiv?.value === 'hoytid' 
    ? 'kontakt_apningstider_hoytid' 
    : 'kontakt_apningstider_normal';
  
  const apningstider = content[activeHoursKey]?.value.split(',') || [];

  return (
    <div className="contact-info-container">
      <h3>Kontaktinformasjon</h3>
      <div className="contact-info-block">
        <a href={`mailto:${content.kontakt_email?.value}`} className="contact-info-item">
          <strong>E-post:</strong> {content.kontakt_email?.value}
        </a>
        <a href={`tel:${content.kontakt_telefon?.value}`} className="contact-info-item">
          <strong>Telefon:</strong> {content.kontakt_telefon?.value}
        </a>
        <a href={content.kontakt_adresse_link?.value} target="_blank" rel="noopener noreferrer" className="contact-info-item">
          <strong>Adresse:</strong> {content.kontakt_adresse_tekst?.value}
        </a>
      </div>
      <div className="opening-hours-wrapper">
        <button onClick={() => setIsHoursOpen(!isHoursOpen)} className="button opening-hours-button">
          Se Åpningstider
          <span className={`info-button-arrow ${isHoursOpen ? 'open' : ''}`}>&#8250;</span>
        </button>
        <div className={`opening-hours-dropdown ${isHoursOpen ? 'open' : ''}`}>
          {isHoytid && (<p className="hoytid-notice">Høytid</p>)}
          <ul className="opening-hours-list">
            {apningstider.map((tid, index) => <li key={index}>{tid}</li>)}
          </ul>
        </div>
      </div>
      <div className="social-links-container">
        <a href={content.kontakt_facebook_link?.value} target="_blank" rel="noopener noreferrer" className="social-link"><IconFacebook /></a>
        <a href={content.kontakt_instagram_link?.value} target="_blank" rel="noopener noreferrer" className="social-link"><IconInstagram /></a>
        <a href={content.kontakt_kart_link?.value} target="_blank" rel="noopener noreferrer" className="social-link"><IconMapPin /></a>
      </div>
    </div>
  );
}

export default ContactInfo;